var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cmp bkr-cc coupon-input" }, [
    _vm.isCheckoutReadonly &&
    !!_vm.$translate("Ceres::Template.couponReadonlyInfoText")
      ? _c("p", [
          _vm._v("\n        " + _vm._s(_vm.couponReadonlyInfoText) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          "input-group": true,
          "component-loading": _vm.isCheckoutReadonly,
          "is-loading": _vm.isCheckoutReadonly,
        },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.couponCode,
              expression: "couponCode",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            "aria-label": _vm.$translate("Ceres::Template.couponEnterCoupon"),
            id: "coupon-code-identifier" + _vm._uid,
            placeholder: _vm.$translate("Ceres::Template.couponEnterCoupon"),
            disabled: _vm.disabled || _vm.isCheckoutReadonly,
            "data-testing": "coupon-input",
          },
          domProps: { value: _vm.couponCode },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.redeemCode()
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.couponCode = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "input-group-btn" }, [
          !_vm.disabled
            ? _c(
                "button",
                {
                  staticClass: "btn btn-medium btn-bkm btn-appearance",
                  attrs: {
                    type: "button",
                    disabled: _vm.waiting || _vm.isCheckoutReadonly,
                    "data-testing": "coupon-redeem",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.redeemCode()
                    },
                  },
                },
                [
                  _c("icon", { attrs: { icon: "gift", loading: _vm.waiting } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$translate("Ceres::Template.couponRedeem")) +
                      "\n            "
                  ),
                ],
                1
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-medium btn-danger",
                  attrs: {
                    type: "button",
                    disabled: _vm.waiting || _vm.isCheckoutReadonly,
                    "data-testing": "coupon-remove",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeCode()
                    },
                  },
                },
                [
                  _c("icon", {
                    attrs: { icon: "trash", loading: _vm.waiting },
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$translate("Ceres::Template.couponRemove")) +
                      "\n            "
                  ),
                ],
                1
              ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }